import React from "react"
import styled from "styled-components"
import H2 from "../typography/H2"
import H4 from "../typography/H4"
import P from "../typography/P"
import CardBackground from "./CardBackground"
import Container from "./Container"
import ExternalButton from "./ExternalButton"
import Section from "./Section"
import { ListItem, UnorderedList } from "./UnorderedLists"
import CheckMark from "../../images/home/check.svg"
import { brandPrimaryTheme } from "../../theme"
import { useTheme } from "../../context/ThemeContext"

const planCardData = [
  {
    title: "Essentials",
    buttonText: "Try Now",
    benefits: [
      { benefitName: "Solo entrepreneur" },
      { benefitName: "Just starting out" },
      { benefitName: "Limited contacts" },
    ],
  },
  {
    title: "Premium",
    buttonText: "Try Now",
    benefits: [
      { benefitName: "Small to medium business" },
      { benefitName: "Growing needs" },
      { benefitName: "More contacts" },
    ],
  },
  {
    title: "Ultimate",
    buttonText: "Try Now",
    benefits: [
      { benefitName: "Large / multi-location" },
      { benefitName: "Advanced marketer" },
      { benefitName: "Most contacts" },
    ],
  },
]

const PlansDesignedForYourNeeds = () => {
  const themeToggle = useTheme()
  const onClick = (event, planName) => {
    event.preventDefault()
    themeToggle.saveTrialPlan(planName)
  }
  return <>
    <Section
      tint="#f1f5f8"
      clipPath="polygon(100% 0, 100% calc(100% - 6vw), 51% 100%, 0 calc(100% - 6vw), 0 0)"
    >
      <StyledH2>Plans Designed to Fit Your Needs and Grow with You</StyledH2>
    </Section>
    <Section className="view-plan-padding">
      <Container className="padding-top-bottom-20">
        {planCardData.map(({ title, buttonText, benefits }) => (
          <PlanCardBackground key={title}>
            <H4>{title}</H4>
            <UnorderedList>
              {benefits &&
                benefits.map(({ benefitName }) => (
                  <ListItem>
                    <img
                      className="margin-right-10"
                      src={CheckMark}
                      alt="check"
                      title="check"
                    />
                    <P>{benefitName}</P>
                  </ListItem>
                ))}
            </UnorderedList>
            <ExternalButton onClick={(event) => onClick(event, title)}>{buttonText}
            </ExternalButton>
          </PlanCardBackground>
        ))}
      </Container>
    </Section>
  </>
}

export default PlansDesignedForYourNeeds

const PlanCardBackground = styled(CardBackground)`
  padding: 20px;
  ${({ theme }) => theme.se`
    margin-bottom: 40px;
  `}

  ${({ theme }) => theme.desktop`
    width: 31%;

    
  `};

  img {
    margin-right: 10px;
  }
  ul {
    width: 100%;
  }
`

const CustomContainer = styled(Container)`
  ${({ theme }) => theme.se`
   padding-bottom: 0;
  `}
  ${({ theme }) => theme.desktop`
    display: flex;
    padding-top: 0;
    justify-content: center
  `}
`

const ViewPlans = styled(P)`
  color: ${brandPrimaryTheme};
  text-decoration: none;
  ${({ theme }) => theme.se`
     font-size: 25px;
     text-align: center;
  `}
  ${({ theme }) => theme.desktop`
     font-size: 30px;
  `}
`

const StyledH2 = styled(H2)`
  text-align: center;
`
